// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___2vxVz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SalesOrderReport/style.scss
// module id = 1870
// module chunks = 0